import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8};
  align-items: flex-start;
`

export const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`
